import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { CardSkeleton } from '@/components/loading'
import { QueryError } from '@/components/error'
import { cn } from '@/utils'
import { useStatCards } from './StatCards.logic'

export function StatCards() {
  const { stats, isLoading, isError } = useStatCards()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (isError) {
    return <QueryError />
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.labelKey}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.label}
            </CardTitle>
            <div className={cn('rounded-lg p-2', stat.colorClass)}>
              <stat.icon className="size-4" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
